import angular from 'angular'
import checkboxDirective from './checkboxDirective'

export default angular
    .module('app.checkbox', [])
    .directive('checkbox', checkboxDirective)
    .name



// WEBPACK FOOTER //
// ./src/components/checkbox/index.js